import React, { useState } from 'react';
import PropTypes from 'prop-types';
import posed, { PoseGroup } from 'react-pose';
import { css } from '@emotion/core';

import config from 'config';
import Modal from 'common/modal';
import Markdown from 'common/markdown';
import Button from 'common/button';
import Icon from 'common/icon';

const fullTermsStyles = css`
    a {
        color: ${config('/tailwind/colors/green50')};

        &:hover {
            color: ${config('/tailwind/colors/green70')};
        }
    }
    p,
    ul,
    ol {
        + p,
        + ul,
        + ol {
            margin-top: ${config('/tailwind/margin/8')};
        }
    }
`;

const CheckedIconPose = posed.div({
    enter: { scale: 1, opacity: 1, duration: 100 },
    exit: { scale: 0.9, opacity: 0, duration: 100 },
});

const ThirdPartyTerms = ({ isAccepted, statement, fullTerms, onChange }) => {
    const [showFullTerms, setShowFullTerms] = useState(false);

    return (
        <>
            <div className="text-center text-12 font-medium">
                <button
                    type="button"
                    onClick={() => onChange(!isAccepted)}
                    className="w-full flex justify-center text-gray-40 leading-normal"
                    data-testid="thirdPartyConsentButton"
                >
                    <div className="text-xl w-16 flex-no-shrink">
                        <PoseGroup withParent={false} animateOnMount>
                            <CheckedIconPose key={isAccepted ? 'icon1' : 'icon2'}>
                                <Icon
                                    icon={isAccepted ? 'check-square' : 'square'}
                                    type="regular"
                                    fixedWidth
                                    className="text-green"
                                    data-testid="thirdPartyIcon"
                                />
                            </CheckedIconPose>
                        </PoseGroup>
                    </div>
                    <div css={{ paddingTop: 10 }}>{statement}</div>
                </button>

                {fullTerms && (
                    <p className="mt-4">
                        <button
                            type="button"
                            className="link-green cursor-pointer"
                            onClick={() => setShowFullTerms(true)}
                        >
                            Click for full details
                        </button>
                    </p>
                )}
            </div>
            <Modal close={() => setShowFullTerms(false)} isOpen={showFullTerms}>
                <div className="p-12">
                    <Markdown css={fullTermsStyles}>{fullTerms}</Markdown>
                    <Button
                        type="button"
                        size="md"
                        color="gray"
                        className="mt-8 text-16 font-medium w-full text-white"
                        onClick={() => setShowFullTerms(false)}
                    >
                        Close
                    </Button>
                </div>
            </Modal>
        </>
    );
};

ThirdPartyTerms.propTypes = {
    statement: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    isAccepted: PropTypes.bool,
    fullTerms: PropTypes.string,
};

ThirdPartyTerms.defaultProps = {
    isAccepted: false,
    fullTerms: null,
};

export default ThirdPartyTerms;
